<template>
  <div v-bind:class="{loading: isLoading}" id="buy-cart" class="columns">
    <div class="column">
      <h2 class="subtitle">Shopping Cart</h2>
      <table class="table">
        <thead>
          <tr>
            <th width="100">Qty</th>
            <th>Name</th>
            <th>Set</th>
            <th>Condition</th>
            <th>Item Price</th>
            <th>Total Price</th>
            <th></th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="li in checkout.lineItems">
            <td><input class="input" type="number" v-bind:value.number="li.quantity" @change="updateLineItemQuantity(li, $event.target.value)"></td>
            <td>{{ li.title }}</td>
            <td>{{ setName(li.variant.id) }}</td>
            <td>{{ li.variant.title }}</td>
            <td>${{ li.variant.price }}</td>
            <td>${{ lineTotal(li) }}</td>
            <td><a @click.prevent="removeFromCart(li)" class="button is-primary">Delete</a></td>
          </tr>
        </tbody>
        <tfoot>
          <tr>
            <td colspan="5"></td>
            <td>${{ subtotal(checkout) }}</td>
            <td></td>
          </tr>
          <tr>
            <td colspan="5"></td>
            <td><a @click.prevent="clearCart" class="button is-primary">Clear Cart</a></td>
            <td><a @click.prevent="checkoutCart" class="button is-primary">Checkout Cart</a></td>
          </tr>
        </tfoot>
      </table>
    </div>
  </div>
</template>

<script>
import Raven from 'raven-js';
import Client from 'shopify-buy';
import { variantId, decodeVariantId } from '../shopify-ids';

export default {
  name: 'buycart',
  data() {
    return {
      isLoading: false,
      checkout: {},
      client: null,
      cardDetails: [],
    };
  },
  methods: {
    clearCart() {
      this.checkout.lineItems.forEach(li => this.removeFromCart(li));
    },
    updateLineItemQuantity(li, q) {
      const lineItems = [
        { id: li.id, quantity: 1 },
      ];

      const cd = this.cardDetails.find(d => variantId(d.variant_id) === li.variant.id);

      if (Number(q) > cd.quantity) {
        lineItems[0].quantity = li.quantity;
      } else if (Number(q) > 1) {
        lineItems[0].quantity = Math.floor(Number(q));
      }

      this.client.checkout.updateLineItems(localStorage.getItem('shopifyCheckoutId'), lineItems).then((checkout) => {
        this.checkout = checkout;
      });
    },
    removeFromCart(li) {
      this.client.checkout.removeLineItems(localStorage.getItem('shopifyCheckoutId'), [li.id]).then((checkout) => {
        this.checkout = checkout;
      });
    },
    checkoutCart() {
      window.location.href = this.checkout.webUrl;
    },
    setName(v) {
      const cd = this.cardDetails.find(d => variantId(d.variant_id) === v);
      if (cd !== undefined) {
        return cd.set_name;
      }

      return '';
    },
    lineTotal(li) {
      return (li.variant.price * li.quantity).toFixed(2);
    },
    subtotal(checkout) {
      if (!checkout.lineItems) {
        return 0;
      }

      let total = 0;

      checkout.lineItems.forEach((li) => {
        total += (li.variant.price * li.quantity);
      });

      return total.toFixed(2);
    },
  },
  mounted() {
    this.isLoading = true;

    this.client = Client.buildClient({
      storefrontAccessToken: 'c532a34d42a102560faf84bbb93624f1',
      domain: 'powernine.myshopify.com',
      appId: '6',
    });

    new Promise((resolve) => {
      if (localStorage.getItem('shopifyCheckoutId')) {
        resolve(this.client.checkout.fetch(localStorage.getItem('shopifyCheckoutId')));
      }

      resolve(null);
    }).then((checkout) => {
      if (!checkout) {
        return this.client.checkout.create();
      }

      return checkout;
    }).then((checkout) => {
      this.checkout = checkout;
      localStorage.setItem('shopifyCheckoutId', checkout.id);
    }).then(() => {
      const variantIds = this.checkout.lineItems.map(li => li.variant.id);
      let query = '';
      for (let i = 0; i < variantIds.length; i += 1) {
        query += `&variant_id[]=${decodeVariantId(variantIds[i])}`;
      }
      return this.axios.get(`https://inventory.powernine.com/shopify/variants?${query}`);
    })
    .then((response) => {
      this.cardDetails = response.data;
      this.isLoading = false;
    })
    .catch((err) => {
      this.isLoading = false;
      Raven.captureException(err);
    });
  },
  watch: {
    // eslint-disable-next-line
    '$route': function (to) {
      this.loadCollection(to.params.id);
    },
  },
};
</script>



// WEBPACK FOOTER //
// BuyCart.vue?673e43d2